<template>
  <div id="pansim-app-wrapper">
    <div class="pc-only-top-banner">
      <div class="bar-content">
        <p class="msg">
          <span class="bold">판심 법무법인</span>은 주말/공휴일/야간에도 <span class="blue">24시간 상담</span>이 가능합니다.
        </p>
        <a href="tel:010-8702-0200" class="call-link">📞 전화상담 010-8702-0200</a>
      </div>
    </div>

    <div class="main-body-container">
      <router-view :key="$i18n.locale"/>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            timer: null,
            latest: Date.now(),
        };
    },
    created(){
        this.init();
    },
    methods: {
        init(){
            document.addEventListener("mousemove", this.reset, false);
            document.addEventListener("mousedown", this.reset, false);
            document.addEventListener("keypress", this.reset, false);
            document.addEventListener("touchmove", this.reset, false);
            document.addEventListener("onscroll", this.reset, false);
            this.onTimer();
        },
        reset(){
            this.latest = Date.now();
        },
        onTimer(){
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if(24 * 60 * 60 * 1000 < (Date.now() - this.latest) || this.payload.exp * 1000 <= Date.now()){
                    this.$store.dispatch("logout");
                }
                this.onTimer();
            }, 1000);
        },
    },
    computed: {
        refreshToken(){ return this.$store.state.refreshToken; },
        accessToken(){ return this.$store.state.accessToken; },
        payload(){ return JSON.parse(atob(this.refreshToken?.split('.')[1] || '') || "{}"); }
    },
    watch: {
        accessToken(){
            if(!this.accessToken){
                alert("로그아웃 되었습니다");
                this.$router.push("/");
            }
        }
    }
}
</script>

<style scoped>
/* --- PC 전용 스타일 (1200px 이상) --- */
@media (min-width: 1200px) {
  .pc-only-top-banner {
    position: fixed; /* 상단 고정 */
    top: 0;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
    padding: 10px 0; /* 상하 여백 1배 크기 조절 */
    z-index: 10000;
  }

  .bar-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding: 0 20px;
  }

  .msg {
    margin: 0;
    font-size: 19px; /* 원래 크기(1배)로 복구 */
    color: #333;
  }

  .bold { font-weight: 700; }
  .blue { color: #0078D4; font-weight: 700; }

  .call-link {
    background-color: #0078D4;
    color: #ffffff !important;
    padding: 6px 14px;
    border-radius: 4px;
    font-size: 15px;
    text-decoration: none;
    font-weight: 600;
  }

  /* PC에서 배너가 고정된 만큼 본문을 아래로 밀어줌 */
  .main-body-container {
    margin-top: 45px; /* 배너 높이만큼만 살짝 밀어줌 */
  }
}

/* --- 모바일/태블릿 스타일 (1200px 미만) --- */
@media (max-width: 1199px) {
  /* 배너를 아예 보이지 않게 하여 모바일 레이아웃 복구 */
  .pc-only-top-banner {
    display: none !important;
  }

  /* 모바일 여백 강제 초기화 */
  .main-body-container {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
}
</style>
